import React, { ChangeEvent, FC, useState, useEffect } from 'react';
import clsx from 'clsx';
import { Slider as MaterialSlider } from '@material-ui/core';
import { StylesProvider } from '@material-ui/core/styles';
import { formatMonetaryAmount } from 'utils/formatMonetaryAmount';

import styles from './RangeSlider.module.scss';
import sliderCustomStyles from './SliderCustomStyles.module.scss';

interface RangeSliderProps {
  min: number;
  max: number;
  onChange: (newValue: number) => void;
  value: number | number[];
  step: number;
  handleBlur?: () => void;
  className?: string;
  isLoading?: boolean;
  disabled?: boolean;
}

const RangeSlider: FC<RangeSliderProps> = ({
  min,
  max,
  step,
  onChange,
  value,
  handleBlur,
  className,
  isLoading,
  disabled,
}) => {
  const [sliderValue, setSliderValue] = useState(value as number);

  useEffect(() => {
    setSliderValue(value as number);
  }, [value]);

  const clampValue = (newValue: number) => Math.min(Math.max(newValue, min), max);

  const handleChange = (_: ChangeEvent<{}>, newValue: number | number[]) => {
    setSliderValue(clampValue(newValue as number));
    onChange(clampValue(newValue as number));
  };

  return (
    <div className={clsx(styles.mainContainer, className)}>
      <h1 className={clsx(styles.title, isLoading && styles.loadingTitle)}>{formatMonetaryAmount(sliderValue)}</h1>
      <StylesProvider injectFirst>
        <MaterialSlider
          min={min}
          max={max}
          step={step}
          classes={sliderCustomStyles}
          onChange={handleChange}
          onChangeCommitted={handleBlur}
          value={sliderValue}
          disabled={disabled || isLoading}
        />
      </StylesProvider>
      <div className={clsx(styles.amountContainer, isLoading && styles.loadingAmount)}>
        <p>{formatMonetaryAmount(min)}</p>
        <p>{formatMonetaryAmount(max)}</p>
      </div>
    </div>
  );
};

export default RangeSlider;
